// 产品展示缩略图的映射配置
// 可以根据需要随时修改这些图片路径

export const productThumbnails = {
  gpt: [
    '/images/gpt-main.jpg', // 第一个始终是主图
    '/images/gpt/2.jpg',
    '/images/gpt/7.jpg',
    '/images/gpt/3.jpg',
    '/images/gpt/4.jpg',
    '/images/gpt/5.jpg',
    '/images/gpt/6.jpg',
    '/images/gpt/10.jpg',
  ],
  app: [
    '/images/gpt-main.jpg', // 第一个始终是主图
    '/images/gpt/8.jpg',
    '/images/gpt/9.jpg',
    '/images/gpt/10.jpg',
  ],
  renew: [
    '/images/renew-main.jpg', // 续费产品专用主图
    '/images/gpt/8.jpg',
    '/images/gpt/9.jpg',
    '/images/gpt/10.jpg',
  ],
  sora: [
    '/images/sora-main.jpg', // 第一个始终是主图
    '/images/gpt/2.jpg',
    '/images/gpt/7.jpg',
    '/images/gpt/3.jpg',
    '/images/gpt/4.jpg',
    '/images/gpt/5.jpg',
    '/images/gpt/6.jpg',
    '/images/gpt/10.jpg',
  ],
  vip: [
    '/images/vip-main.jpg', // 第一个始终是主图
    '/images/vip-thumb-2.jpg',
    '/images/vip-thumb-3.jpg',
    '/images/vip-thumb-4.jpg',
    '/images/vip-thumb-5.jpg',
    '/images/vip-thumb-6.jpg',
    '/images/vip-thumb-7.jpg',
  ],
  grok: [
    '/images/grok-main.jpg', // 第一个始终是主图
    '/images/gpt/14.jpg',    
    '/images/gpt/15.jpg',    
    '/images/gpt/16.jpg',   
    '/images/gpt/17.jpg',     
    '/images/gpt/10.jpg',    
  ],
  claude: [
    '/images/claude-main.jpg', // 第一个始终是主图
    '/images/gpt/11.jpg',    
    '/images/gpt/12.jpg',    
    '/images/gpt/17.jpg',     
    '/images/gpt/10.jpg',    
  ],
  mj: [
    '/images/mj-main.jpg', // 第一个始终是主图
    '/images/mj-thumb-1.jpg',
    '/images/mj-thumb-2.jpg',
    '/images/mj-thumb-3.jpg',
    '/images/mj-thumb-4.jpg',
    '/images/mj-thumb-5.jpg'
  ],
  default: [
    '/images/default-main.jpg', // 第一个始终是主图
    '/images/default-thumb-1.jpg',
    '/images/default-thumb-2.jpg',
    '/images/default-thumb-3.jpg',
    '/images/default-thumb-4.jpg',
    '/images/default-thumb-5.jpg'
  ]
};

/**
 * 根据产品类型获取对应的缩略图数组
 * @param {string} productType - 产品类型 (gpt, sora, vip, etc.)
 * @returns {string[]} - 图片路径数组
 */
export const getProductImages = (productType) => {
  return productThumbnails[productType] || productThumbnails.default;
};

/**
 * SKU产品类型到图片类型的映射
 * @param {string} skuProductType - SKU产品类型
 * @returns {string} - 对应的图片类型
 */
const mapSkuTypeToImageType = (skuProductType) => {
  const mapping = {
    'official': 'gpt',           // 官网独享账号 -> gpt图片
    'official-renewal': 'renew',  // 官网续费 -> renew图片
    'official-shared': 'gpt',     // 官网共享账号 -> gpt图片
    'shared': 'gpt',             // 网页共享托管账号 -> gpt图片
    'monkeyai': 'app',           // MonkeyAI -> app图片
    'app': 'app',                // 兼容旧的app类型
    'renew': 'renew',            // 兼容旧的renew类型
    'gpt': 'gpt',                // 兼容旧的gpt类型
    'sora': 'sora',              // Sora
    'vip': 'vip',                // VIP
    'grok': 'grok'               // Grok
  };
  
  return mapping[skuProductType] || 'gpt'; // 默认使用gpt图片
};

/**
 * 获取产品主图（第一张图片）
 * @param {string} productType - 产品类型（支持新的SKU类型和旧的类型）
 * @returns {string} - 主图路径
 */
export const getProductMainImage = (productType) => {
  const imageType = mapSkuTypeToImageType(productType);
  const images = getProductImages(imageType);
  return images[0];
};

/**
 * 获取所有可用的产品类型
 * @returns {string[]} - 产品类型数组
 */
export const getAvailableProductTypes = () => {
  return Object.keys(productThumbnails).filter(type => type !== 'default');
}; 